<template>
  <div
    id="teams-view"
    class="pa-4"
  >
    <view-page-header :show-team-select="false" />
    <v-divider class="mb-6" />
    <section>
      <v-row
        justify="center"
      >
        <v-col
          xl="4"
          lg="6"
          md="9"
        >
          <v-card>
            <v-card-title class="d-flex justify-space-between">
              <div class="subtitle-2">
                {{ $t('card_title.connected_polar_teams') }}
              </div>
              <v-btn
                text
                color="primary"
                class="text-none"
                :href="polarTeamAuthorizeUrl"
                target="_blank"
              >
                {{ $t('button.connect_polar_team') }}
                <v-icon
                  right
                  x-small
                >
                  far fa-plus
                </v-icon>
              </v-btn>
            </v-card-title>
            <v-divider />
            <v-card-text>
              <v-list
                v-if="polarTeamOrganisations.length > 0"
                class="v-list--bordered pa-0"
              >
                <template
                  v-for="organisation in polarTeamOrganisations"
                >
                  <v-list-item
                    :key="'polarteam'+organisation"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ organisation.organisation_name }}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn
                        icon
                        small
                        text
                        color="error"
                        @click="deleteIntegrationId = organisation.polar_team_integration_id; deleteConfirmationDialogVisible = true"
                      >
                        <v-icon small>
                          far fa-times
                        </v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-list>
              <div
                v-else
                class="grey--text text-body-1 pa-6"
              >
                {{ $t('data_empty.connected_accounts') }}
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </section>

    <delete-confirmation-dialog
      :visible.sync="deleteConfirmationDialogVisible"
      :submitting="deleting"
      :text="$t('remove_selected_integration.dialog')"
      @confirmed="deleteIntegration()"
    />
  </div>
</template>

<script>
import ViewPageHeader from '@/components/ViewPageHeader'
import DeleteConfirmationDialog from '@/components/dialogs/DeleteConfirmationDialog.vue'
import deleteConfirmationMixin from '@/mixins/deleteConfirmationMixin'
import { AuthApiService } from '@/data/services'

export default {
  name: 'AdminPolarTeamView',
  components: {
    DeleteConfirmationDialog,
    ViewPageHeader
  },
  mixins: [deleteConfirmationMixin],
  data() {
    return {
      deleteIntegrationId: null,
      deleting: false
    }
  },
  computed: {
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    },
    polarTeamIntegration() {
      return this.user.organisation_settings.integrations.find(i => i.key === 'polar-team')
    },
    polarTeamOrganisations() {
      return this.polarTeamIntegration.organisations
    },
    polarTeamAuthorizeUrl() {
      const state = JSON.stringify({
        redirect_uri: window.location.href + '?success=true',
        user_id: this.user.id
      })

      return this.user.polar_team_authorize_url + '&state=' + btoa(state)
    }
  },
  watch: {},
  created() {
    if (this.$route.query.success) {
      this.$store.dispatch(this.$storeActions.ALERT, {
        text: this.$t('alert.connected_polar_team.success'),
        color: 'success'
      })

      this.$router.replace({ query: {} })
    }
  },
  methods: {
    async deleteIntegration() {
      if (!this.deleteIntegrationId) return

      this.deleting = true

      try {
        await AuthApiService.deletePolarTeamIntegration(this.deleteIntegrationId)

        this.$store.dispatch(this.$storeActions.ALERT, {
          color: 'success',
          text: this.$t('alert.integration_removed.success')
        })

        this.deleteIntegrationId = null
        this.deleteConfirmationDialogVisible = false

        const authResponse = await AuthApiService.me()

        this.$store.dispatch(this.$storeActions.AUTH_LOGIN, authResponse.data)
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          color: 'error',
          text: this.$t('alert.removing_integration.error')
        })
        throw e
      } finally {
        this.deleting = false
      }
    }
  }
}
</script>
